import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { hasPermission } from "../../../shared/utils/permissions";

const newRequestSearchSchema = z.object({
  documentTypeId: z.string().optional(),
});

/**
 * @purpose REP: report a broken bike in under a minute
 * @purpose MAT: build a material order for a location
 * @primary Request form (bike/location + lines)
 * @persona sports-manager-ikos, mecanico-externo, paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/requests/new")({
  validateSearch: newRequestSearchSchema,
  beforeLoad: ({ context, params }) => {
    if (
      !context.auth.loading &&
      !hasPermission(context.auth.user, "requests.write")
    ) {
      throw redirect({
        to: "/app/c/$customerSlug/requests",
        params: { customerSlug: params.customerSlug },
      });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
